// 排名管理页面
export const RANK_PAGE_UUID = '9852ce6e-7a0c-4dfb-8e8e-30052c781a21'

// 管理排名
export const RANK_ACTION_UUID = '338e12fc-97c1-48b0-89ce-de6246f61554'
